import React from 'react'
import { NavLink } from 'react-router-dom'
import { List, ListItem, ListItemText } from '@material-ui/core'
import { homeRoute, routes } from '../routes'

export const Navigation = () => {
  const navLinks = [homeRoute, ...routes]

  return (
    <List>
      {navLinks.map(({ title, path }) => (
        <ListItem button component={NavLink} to={path} key={title}>
          <ListItemText primary={title} />
        </ListItem>
      ))}
    </List>
  )
}
